export const STUDIOS_GRID_COLUMNS = ['minmax(220px, 1.2fr)', 'minmax(200px, 1fr)', 'minmax(220px, 1.2fr)'].join(
  ' '
);

export const STUDIO_COLUMNS = [
  {
    id: 'name',
    title: 'Название',
    cellClassName: 'projects-table__cell projects-table__cell_name',
  },
  {
    id: 'legal_entity',
    title: 'Юрлицо',
    cellClassName: 'projects-table__cell projects-table__cell_contractors',
  },
  {
    id: 'notes',
    title: 'Заметки',
    cellClassName: 'projects-table__cell projects-table__cell_base',
  },
] as const;
